// const devDomain = "http://localhost:3500";
const prdDomain = "https://portfolio-server-9e7m.vercel.app";

export const eventTrackingAPI = `${prdDomain}/analytics/event`;
export const pageTrackingAPI = `${prdDomain}/analytics/page`;
export const userDataAPI = `${prdDomain}/user/data`;
